import { axiosInstance } from './axiosConfig';

export function getLogo() {
  return axiosInstance
    .get('/account/logo', {
      responseType: 'blob',
    })
    .then((res) => URL.createObjectURL(res.data));
}
